import {
  Box,
  BrandingContainer,
  Footer as FooterDS,
  FooterItem,
  GlobalFooter,
  Link,
  Logos,
  Typography,
} from '@cambridgeassessment/cambridge-ui';
import React, { memo } from 'react';
import { cold } from 'react-hot-loader';
import { hot } from 'react-hot-loader/root';
import { Link as RouteLink } from 'react-router-dom';
import ISO9001 from 'src/assets/img/ISO9001.png';
import envVars from '../../env';
import { routes } from '../Pages';
import { useStyles } from './styles';

const Footer: React.FC = () => {
  const classes = useStyles();
  const FooterItemCold = cold(FooterItem);
  const BrandingContainerCold = cold(BrandingContainer);

  return (
    <Box className={classes.footer}>
      <FooterDS logoBreakpoint="sm" maxWidth={false}>
        <FooterItemCold title="The Cambridge Family" minWidth="209px">
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridge.org/"
            >
              Cambridge University Press
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridgeassessment.org.uk/"
            >
              Cambridge Assessment
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <RouteLink to={routes.ContactUs.path} target="_blank">
              Contact us
            </RouteLink>
          </Typography>
        </FooterItemCold>
        <FooterItemCold title="Our brands" minWidth="326px">
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.admissionstesting.org/"
            >
              Cambridge Assessment Admissions Testing
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridgeenglish.org/"
            >
              Cambridge Assessment English
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridgeinternational.org/"
            >
              Cambridge Assessment International Education
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cambridgeassessment.org.uk/the-network/"
            >
              Cambridge Assessment Network
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.cem.org/"
            >
              CEM
            </Link>
          </Typography>
          <Typography
            className={classes.paragraph}
            gutterBottom
            variant="body2"
          >
            <Link
              variant="secondary"
              underline="hover"
              href="https://www.ocr.org.uk/"
            >
              OCR
            </Link>
          </Typography>
        </FooterItemCold>
        <BrandingContainerCold>
          <Logos.CambridgeUniversityPressAndAssessment />
          <img src={ISO9001} alt="ISO 9001 Certified" className={classes.iso} />
          {envVars.IS_CHINA && (
            <div className={classes.license} data-testid="icpLicenseString">
              {envVars.ICP_LICENSE_STRING}
            </div>
          )}
        </BrandingContainerCold>
      </FooterDS>
      <GlobalFooter
        copyright={`© ${new Date().getFullYear()} Cambridge University Press and Assessment`}
      >
        <Link href="https://www.cambridgeassessment.org.uk/footer/accessibility/index.aspx">
          Accessibility and Standards
        </Link>
        <Link href="https://www.cambridge.org/legal/privacy">
          Data Protection
        </Link>
        <Link href="https://www.cambridgeassessment.org.uk/footer/use-of-cookies/index.aspx">
          Use of Cookies
        </Link>
        <Link href="https://www.registrarysoffice.admin.cam.ac.uk/governance-and-strategy/anti-slavery-and-anti-trafficking">
          Statement on Modern Slavery
        </Link>
        <Link href="https://www.cambridge.org/legal/website-terms-of-use">
          Terms and Conditions
        </Link>
      </GlobalFooter>
    </Box>
  );
};

export default hot(memo(Footer));
